import { Component,   OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-yes-no-dialog',
  templateUrl: './modal-yes-no-dialog.component.html',
  styleUrls: ['./modal-yes-no-dialog.component.css']
})
export class ModalYesNoDialogComponent implements OnInit {


  constructor(

  ) { 

  }

  ngOnInit(): void {
  }

}
